var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-tiny-info",
    { attrs: { total: _vm.totalIncome, grow: "" } },
    [
      _c("template", { slot: "title" }, [
        _vm._v(" " + _vm._s(_vm.chartData.title) + " "),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }